import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Row } from "reactstrap";
// import ads from "../../../assets/qrcode/advertisement-ads.jpeg";
import logo from "../../../assets/orderingSystem/logo-1.png";
// import "./AllThemeFooter.css";

const ThemeFooter = ({ apiResponse }) => {
  return (
    <div className=" footerBlock">
      {apiResponse && !apiResponse.organization.isPaid && (
        <>
          <Row className="d-flex justify-content-center ">
            <Col lg={6} sm={8} xs={12} className="mb-2">
              <div className="ad-fallback">
                {/* <img
                  src={ads}
                  alt="Advertisement"
                  className=" h-25 w-25"
                /> */}
              </div>
              {/* <ins
                className="adsbygoogle"
                style={{ display: 'block' }}
                data-ad-client="ca-pub-4036596239405267"// // Replace with your AdSense publisher ID
                data-ad-slot="1090252249"// // Replace with your Ad slot ID
                data-ad-format="auto"
                data-full-width-responsive="true"
              ></ins> */}
            </Col>
          </Row>
          <Row className=" p-0 mx-0 mt-2">
            <Col md={12} className="mx-0">
              <p className="responsive-p">
                Create a similar website at <span className="Zero">ZERO</span>{" "}
                cost. Create it yourself as you like !!
              </p>
              <Link to="/register">
                <Button
                  color="warning"
                  size="sm"
                  style={{ fontWeight: "bold" }}
                >
                  Get Started Now
                </Button>
              </Link>
            </Col>
          </Row>
        </>
      )}
      <div className="p-2 d-flex flex-column justify-content-center align-content-center align-items-center bg-dark">
       
          <h5
            style={{
              fontStyle: "italic",
              color: "#c0c0c0",
            }}
        
          >
            Powered by
          </h5>
          <img src={logo} className="img-fluid" style={{}} alt="Danfe Logo" />
   
      </div>
    </div>
  );
};

export default ThemeFooter;
